export default __webpack_public_path__ + "static/media/IBMPlexSans-Thin-Latin1.4226354f.woff2";